import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { GroupInfo } from '../../../assets/finder/gql/generated/GroupInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetCollectionAssetsQueryVariables = Types.Exact<{
  page: Types.PageInput;
  query: Types.CollectionAssetsQueryInput;
}>;


export type GetCollectionAssetsQuery = { __typename?: 'Query', collectionAssets?: { __typename?: 'CollectionAssetsConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, mode?: Types.PaginationModeEnum | null }, groups?: Array<{ __typename?: 'CollectionAssetsGroup', id?: string | null, endCursor?: string | null, values?: Array<{ __typename?: 'CollectionAssetsSortValue', id?: string | null, value?: { __typename?: 'DateFieldValue', date?: string | null } | { __typename?: 'DerivedFieldValue', derived?: string | null } | { __typename?: 'JsonFieldValue', json?: string | null } | { __typename?: 'LinkFieldValue', link?: string | null } | { __typename?: 'LongTextFieldValue', longText?: string | null } | { __typename?: 'NumberFieldValue', number?: number | null } | { __typename?: 'RatingFieldValue', rating?: number | null } | { __typename?: 'SelectFieldValue', selectedOptions?: Array<string> | null } | { __typename?: 'SelectMultiFieldValue', multiSelectedOptions?: Array<string> | null } | { __typename?: 'TextFieldValue', text?: string | null } | { __typename?: 'ToggleFieldValue', toggle?: boolean | null } | { __typename?: 'UrlFieldValue', url?: string | null } | { __typename?: 'UserMultiFieldValue' } | { __typename?: 'UserSingleFieldValue', singleSelectedMember?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', id: string } | { __typename?: 'UserSelectMemberValue', id: string } | null> | null } | { __typename?: 'UsersFieldValue', selectedMembers?: Array<{ __typename?: 'AccountUserGroupSelectMemberValue', id: string } | { __typename?: 'UserSelectMemberValue', id: string } | null> | null } | null }> | null }> | null, nodes: Array<{ __typename?: 'CollectionAsset', id?: string | null, group?: { __typename?: 'CollectionAssetsGroupMembership', id?: string | null } | null }> } | null };


export const GetCollectionAssets = /*#__PURE__*/ gql`
    query GetCollectionAssets($page: PageInput!, $query: CollectionAssetsQueryInput!) {
  collectionAssets(page: $page, query: $query) {
    pageInfo {
      endCursor
      hasNextPage
      mode
    }
    groups {
      id
      ...GroupInfo
    }
    nodes {
      id
      group {
        id
      }
    }
  }
}
    ${GroupInfo}` as unknown as DocumentNode<GetCollectionAssetsQuery, GetCollectionAssetsQueryVariables>;

          

          export const useGetCollectionAssetsQuery = (options?:QueryHookOptions<GetCollectionAssetsQuery, GetCollectionAssetsQueryVariables>) => useQuery(GetCollectionAssets, options);

          

          export type GetCollectionAssetsQueryOptions = QueryHookOptions<GetCollectionAssetsQuery, GetCollectionAssetsQueryVariables>;

          

          export const useGetCollectionAssetsLazyQuery = (options?:LazyQueryHookOptions<GetCollectionAssetsQuery, GetCollectionAssetsQueryVariables>) => useLazyQuery(GetCollectionAssets, options);

          

          export type GetCollectionAssetsQueryResult = ReturnType<typeof useGetCollectionAssetsQuery>;

          
